import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M17.3 3H14.7a2.025 2.025 0 0 0-1.876 1.334l-2.526 7.264a1 1 0 0 0-.052.15L5.289 26H3a1 1 0 1 0 0 2h26a1 1 0 1 0 0-2h-2.289l-4.956-14.253a1 1 0 0 0-.051-.149l-2.522-7.251-.005-.013A2.025 2.025 0 0 0 17.301 3M9.84 19l2.087-6h8.146l2.087 6zm-.695 2-1.739 5h17.188l-1.739-5zm3.477-10h6.756l-2.081-5.985a.03.03 0 0 0-.02-.015h-2.553a.03.03 0 0 0-.02.015z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconTrafficCone = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconTrafficCone);
export default Memo;
